/**
 * iVoodoo Zustands-Runde (Block C, 08.09.2026) - nur Darstellung.
 * 1) Formulare mit data-iv-validate: deutsche Meldung am Feld (aria-describedby,
 *    roter Rahmen), Fehleruebersicht ueber dem Absende-Button, Sprung zum ersten
 *    Fehler. Die Browser-Sprechblase wird unterdrueckt; die HTML-Pruefregeln
 *    (required, type, pattern) und die Absendelogik der Komponenten bleiben.
 * 2) Ankauf-Komponenten: aria-busy beim Laden, Hinweisbox mit „Erneut versuchen“
 *    bei Katalogfehlern, Hilfe-Zeile unter Fehlermeldungen, Schritt-Badges nach
 *    Zustand, Speicher-Platzhalterchips vor der Modellwahl.
 */
(function () {
  'use strict';
  if (window.ivFormsReady) return;
  window.ivFormsReady = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Meldungen ---------- */
  function messageFor(el) {
    var v = el.validity;
    var type = (el.getAttribute('type') || el.tagName).toLowerCase();
    // Block G (17.09.2026): Eine von der Komponente gesetzte eigene Meldung hat Vorrang -
    // sie ist praeziser als jeder Standardsatz hier (z. B. die IBAN-Pruefung des
    // Verkaufsauftrags). customError steht nur nach setCustomValidity() mit Text an.
    if (v.customError && el.validationMessage) return el.validationMessage;
    if (v.valueMissing) {
      if (type === 'checkbox') return 'Bitte bestätige dieses Feld.';
      if (type === 'radio') return 'Bitte wähle eine Option.';
      if (type === 'email') return 'Bitte gib deine E-Mail-Adresse ein.';
      if (type === 'select') return 'Bitte wähle einen Eintrag.';
      if (type === 'file') return 'Bitte wähle eine Datei.';
      return 'Bitte fülle dieses Feld aus.';
    }
    if (v.typeMismatch && type === 'email') return 'Bitte gib eine gültige E-Mail-Adresse ein.';
    if (v.typeMismatch && type === 'url') return 'Bitte gib eine gültige Adresse ein.';
    if (v.patternMismatch) {
      if (type === 'email') return 'Bitte gib eine gültige E-Mail-Adresse ein.';
      if (el.name === 'postalCode' || /plz|postal/i.test(el.name || '')) return 'Bitte gib eine gültige Postleitzahl ein.';
      return 'Bitte prüfe das Format dieser Angabe.';
    }
    if (v.tooShort) return 'Diese Angabe ist zu kurz.';
    if (v.tooLong) return 'Diese Angabe ist zu lang.';
    if (v.rangeUnderflow || v.rangeOverflow || v.stepMismatch) return 'Bitte prüfe den Wert.';
    return 'Bitte prüfe diese Angabe.';
  }

  function isField(el) {
    return el && el.matches && el.matches('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea');
  }

  function wrapperFor(el) {
    if (el.type === 'radio') return el.closest('[role="radiogroup"], fieldset') || el.closest('label') || el.parentElement;
    return el.closest('label, .field, .device-buyback__field') || el.parentElement;
  }

  // Block H (12.09.2026): Eine Radiogruppe hat genau eine Meldung - ihre ID haengt immer am ersten Radio der
  // Gruppe. Vorher bekam sie die ID des gerade ungueltigen Radios; wer danach das zweite Radio waehlte (z. B.
  // "Abgabe" statt "Versand"), fand die Meldung nicht und sie blieb stehen.
  function errorAnchor(el) {
    return el.type === 'radio' ? (radioGroupInputs(el)[0] || el) : el;
  }

  function errorIdFor(el) {
    var anchor = errorAnchor(el);
    if (!anchor.id) anchor.id = 'iv-field-' + Math.random().toString(36).slice(2, 8);
    return anchor.id + '-error';
  }

  function radioGroupInputs(el) {
    var form = el.form || document;
    return Array.prototype.slice.call(form.querySelectorAll('input[type="radio"][name="' + el.name + '"]'));
  }

  function showError(el) {
    if (!isField(el)) return;
    var wrap = wrapperFor(el);
    var id = errorIdFor(el);
    var msg = document.getElementById(id);
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'iv-field-error';
      msg.id = id;
      // Block B (12.09.2026): Die Meldung ist immer das letzte Kind der Feldhuelle. Vorher
      // landete sie zwischen Feld und Beschriftung - die schwebende Beschriftung fiel dann
      // zurueck ins Feld und ueberdeckte die Eingabe.
      if (wrap && wrap !== el && wrap.contains(el)) wrap.appendChild(msg);
      else el.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = messageFor(el);
    var targets = el.type === 'radio' ? radioGroupInputs(el) : [el];
    targets.forEach(function (t) {
      t.setAttribute('aria-invalid', 'true');
      t.classList.add('iv-invalid');
      var d = (t.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (d.indexOf(id) < 0) d.push(id);
      t.setAttribute('aria-describedby', d.join(' '));
    });
    if (wrap) wrap.classList.add('iv-field--error');
  }

  function clearError(el) {
    if (!isField(el)) return;
    var anchor = errorAnchor(el);
    var id = anchor.id ? anchor.id + '-error' : null;
    var msg = id && document.getElementById(id);
    if (msg) msg.remove();
    var targets = el.type === 'radio' ? radioGroupInputs(el) : [el];
    targets.forEach(function (t) {
      t.removeAttribute('aria-invalid');
      t.classList.remove('iv-invalid');
      if (id) {
        var d = (t.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== id; });
        if (d.length) t.setAttribute('aria-describedby', d.join(' ')); else t.removeAttribute('aria-describedby');
      }
    });
    var wrap = wrapperFor(el);
    if (wrap && !wrap.querySelector('.iv-field-error')) wrap.classList.remove('iv-field--error');
  }

  function invalidFields(form) {
    var seen = {};
    return Array.prototype.filter.call(form.querySelectorAll('input, select, textarea'), function (el) {
      if (!isField(el) || el.disabled || el.closest('[hidden]')) return false;
      if (el.type === 'radio') { if (seen[el.name]) return false; seen[el.name] = true; }
      // checkValidity() loest das Ereignis 'invalid' aus und markiert dadurch unberuehrte
      // Felder rot. willValidate + validity.valid fragt denselben Zustand ohne Nebenwirkung ab.
      return el.willValidate && !el.validity.valid;
    });
  }

  function showSummary(form, count) {
    var summary = form.querySelector('.iv-form-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'iv-alert iv-form-summary';
      summary.setAttribute('role', 'alert');
      var body = document.createElement('div');
      body.className = 'iv-alert__body';
      summary.appendChild(body);
      var submit = form.querySelector('[type="submit"]');
      if (submit && submit.parentNode) submit.parentNode.insertBefore(summary, submit); else form.appendChild(summary);
    }
    summary.querySelector('.iv-alert__body').textContent = count === 1
      ? 'Bitte prüfe die markierte Angabe.'
      : 'Bitte prüfe die ' + count + ' markierten Angaben.';
  }

  function removeSummary(form) {
    var summary = form.querySelector('.iv-form-summary');
    if (summary) summary.remove();
  }

  function focusFirst(el) {
    var target = el.type === 'radio' ? (el.closest('[role="radiogroup"], fieldset') || el) : el;
    try { target.scrollIntoView({ block: 'center', behavior: REDUCE ? 'auto' : 'smooth' }); } catch (e) {}
    window.setTimeout(function () {
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    }, REDUCE ? 0 : 260);
  }

  function enhanceForm(form) {
    if (form.ivEnhanced) return;
    form.ivEnhanced = true;
    form.setAttribute('novalidate', '');
    // Native Sprechblasen unterdruecken (auch wenn eine Komponente reportValidity() aufruft) und
    // stattdessen die Meldung am Feld zeigen.
    form.addEventListener('invalid', function (event) {
      event.preventDefault();
      showError(event.target);
    }, true);
    var onEdit = function (event) {
      var el = event.target;
      if (!isField(el)) return;
      // Block B: Ab der ersten eigenen Eingabe gilt das Feld als angefasst - nur solche Felder
      // duerfen beim Verlassen markiert werden.
      el.ivTouched = true;
      if (!el.willValidate || el.validity.valid) {
        clearError(el);
        if (!invalidFields(form).length) removeSummary(form);
      }
    };
    form.addEventListener('input', onEdit);
    form.addEventListener('change', onEdit);
    // Block B: Meldung beim Verlassen eines selbst ausgefuellten, ungueltigen Feldes. Vorher kam sie
    // als Nebenwirkung von checkValidity() - und traf dadurch auch unberuehrte Felder.
    form.addEventListener('focusout', function (event) {
      var el = event.target;
      if (!isField(el) || !el.ivTouched) return;
      if (el.willValidate && !el.validity.valid) showError(el);
    }, true);
    form.addEventListener('submit', function (event) {
      var invalid = invalidFields(form);
      if (!invalid.length) { removeSummary(form); return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid.forEach(showError);
      showSummary(form, invalid.length);
      focusFirst(invalid[0]);
    }, true);
    if (form.hasAttribute('data-iv-required-hint') && form.querySelector('[required]') && !form.querySelector('.iv-required-hint')) {
      var hint = document.createElement('p');
      hint.className = 'iv-required-hint';
      hint.textContent = '* Pflichtfeld';
      var submit = form.querySelector('[type="submit"]');
      var host = submit ? (submit.closest('.columns') || submit.parentNode) : form;
      host.insertBefore(hint, host.firstChild);
    }
  }

  /* ---------- Ankauf-Komponenten ---------- */
  function funnel(root) {
    if (root.ivFunnelReady) return;
    root.ivFunnelReady = true;
    var step1 = root.querySelector('.ivoodoo-selection-panel');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.smartphone-buyback__steps .smartphone-buyback__panel'));
    var steps = [step1].concat(panels).filter(Boolean);
    // Schritte den vorhandenen Zusammenfassungswerten zuordnen (Geraete: Hersteller, Modell,
    // Speicher, Zustand; manuelle Anfrage ohne Speicher: Hersteller, Modell, Zustand).
    var keys = ['[data-summary-brand]', '[data-summary-model]', '[data-summary-storage]', '[data-summary-condition]'].filter(function (sel) { return !!root.querySelector(sel); });
    var text = function (sel) { var el = root.querySelector(sel); return el ? el.textContent.trim() : ''; };
    var filled = function (sel) { var t = text(sel); return t !== '' && t !== '—' && t !== '-' && t !== '–'; };

    function syncSteps() {
      if (!steps.length) return;
      var current = false;
      steps.forEach(function (panel, i) {
        panel.classList.remove('iv-step--done', 'iv-step--current', 'iv-step--upcoming');
        if (keys[i] && filled(keys[i])) panel.classList.add('iv-step--done');
        else if (!current) { panel.classList.add('iv-step--current'); current = true; }
        else panel.classList.add('iv-step--upcoming');
      });
    }
    var summary = root.querySelector('.smartphone-buyback__summary-card dl');
    if (summary) new MutationObserver(syncSteps).observe(summary, { childList: true, characterData: true, subtree: true });
    syncSteps();

    // Speicher: Platzhalterchips (Sichtbarkeit steuert CSS ueber den Zustand der Komponente)
    var storageWrap = root.querySelector('[data-storage-wrap]');
    if (storageWrap && !root.querySelector('.iv-storage-placeholder')) {
      var ph = document.createElement('div');
      ph.className = 'iv-storage-placeholder';
      ph.setAttribute('aria-hidden', 'true');
      ph.innerHTML = '<span>—</span><span>—</span><span>—</span><p class="iv-storage-placeholder__hint">Verfügbar nach der Modellwahl</p>';
      storageWrap.insertAdjacentElement('afterend', ph);
    }

    // Katalog: Ladezustand ansagen, Fehler mit „Erneut versuchen“
    var brands = root.querySelector('[data-brands]');
    var empty = root.querySelector('[data-catalog-empty]');
    var status = root.querySelector('[data-status]');
    function syncCatalog() {
      if (!brands) return;
      brands.setAttribute('aria-busy', brands.hasAttribute('data-loading') ? 'true' : 'false');
      // Block B: Der Kasten haengt am Zustand der Komponente, nicht an der Fehlerklasse
      // der Statuszeile - sonst erscheinen zwei widersprechende Flaechen (oder keine).
      var failed = root.hasAttribute('data-catalog-failed');
      var host = root.querySelector('.iv-catalog-alert');
      if (failed) {
        if (!host && empty) {
          host = document.createElement('div');
          host.className = 'iv-alert iv-catalog-alert';
          host.setAttribute('role', 'alert');
          host.innerHTML = '<div class="iv-alert__body"><span class="iv-catalog-alert__text"></span><div class="iv-alert__actions"><button type="button" class="iv-catalog-retry">Erneut versuchen</button><a href="/pages/contact">Kontakt</a></div></div>';
          empty.insertAdjacentElement('afterend', host);
          host.querySelector('.iv-catalog-retry').addEventListener('click', function () {
            if (typeof root.loadCatalog !== 'function') { window.location.reload(); return; }
            brands.setAttribute('data-loading', '');
            if (status) { status.classList.remove('is-error'); status.replaceChildren(); }
            empty.hidden = true;
            host.remove();
            root.removeAttribute('data-catalog-failed');
            // Block G (17.09.2026): Der Kasten nimmt beim Entfernen den Fokus mit - danach
            // stand er auf <body>, und wer mit der Tastatur arbeitet, musste sich von ganz
            // oben erneut durch die Seite tabben. Nach dem Nachladen gehoert er dorthin, wo
            // es weitergeht: auf den ersten Hersteller, sonst auf die Auswahlflaeche selbst.
            Promise.resolve(root.loadCatalog()).then(function () {
              var ziel = brands.querySelector('button');
              if (!ziel) { if (!brands.hasAttribute('tabindex')) brands.setAttribute('tabindex', '-1'); ziel = brands; }
              try { ziel.focus({ preventScroll: true }); } catch (e) { ziel.focus(); }
            }, function () { /* Bleibt der Fehler bestehen, baut syncCatalog den Kasten neu auf. */ });
          });
        }
        if (host) host.querySelector('.iv-catalog-alert__text').textContent = root.dataset.catalogError || 'Die Geräteauswahl konnte nicht geladen werden. Bitte versuche es noch einmal.';
        // Block B: Faellt die Katalogantwort schneller als dieses Skript, hat die Komponente ihren
        // Ersatzsatz schon in die Statuszeile geschrieben. Sobald der Kasten steht, gehoert ihm die
        // Anzeige allein - sonst stehen zwei gleichlautende Flaechen untereinander.
        if (host && status && status.textContent.trim()) { status.classList.remove('is-error'); status.replaceChildren(); }
      } else if (host) {
        host.remove();
      }
    }
    if (brands) new MutationObserver(syncCatalog).observe(brands, { attributes: true, attributeFilter: ['data-loading'], childList: true });
    if (empty) new MutationObserver(syncCatalog).observe(empty, { attributes: true, attributeFilter: ['hidden'] });
    if (status) new MutationObserver(syncCatalog).observe(status, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(syncCatalog).observe(root, { attributes: true, attributeFilter: ['data-catalog-failed'] });
    syncCatalog();

    // Hilfe-Zeile unter Fehlermeldungen (Angebot, Verkaufsauftrag)
    var wa = (document.querySelector('a[href^="https://wa.me/"]') || {}).href || '';
    Array.prototype.forEach.call(root.querySelectorAll('.smartphone-buyback__status'), function (el) {
      var sync = function () {
        if (el.classList.contains('is-error') && el.textContent.trim() && !el.querySelector('.iv-status-help')) {
          var help = document.createElement('span');
          help.className = 'iv-status-help';
          help.innerHTML = 'Hilfe: ' + (wa ? '<a href="' + wa + '" target="_blank" rel="noopener">WhatsApp</a> · ' : '') + '<a href="/pages/contact">Kontakt</a>';
          el.appendChild(help);
        }
      };
      new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['class'], childList: true, characterData: true, subtree: true });
      sync();
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form[data-iv-validate]'), enhanceForm);
    Array.prototype.forEach.call(document.querySelectorAll('.smartphone-buyback'), funnel);
    new MutationObserver(function () {
      Array.prototype.forEach.call(document.querySelectorAll('form[data-iv-validate]'), enhanceForm);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
